import * as React from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { AppState } from "../../../redux";

import { Person } from "@radivision/graphql/lib/ts/graphql/person";

interface MapStateProps {
  user: Person | null;
}

export type Props = MapStateProps;

export const Component = (props: Props) => {
  const { user } = props;

  if (!user) return null;
  const DynamicEditProfileModal = Loadable({
    loader: () => import("../../../modules/manage-profile").then((module) => module.EditProfileModal) as Promise<any>,
    loading: () => null,
  });
  return <DynamicEditProfileModal />;
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const EditProfileModal = connect(mapState, mapDispatch)(Component);
